import React from 'react';
import _ from 'lodash';
import { Button, FormControl, InputLabel, Select, OutlinedInput, MenuItem, ListItemText } from '@mui/material';
import { getJsonFormsAction } from '../../services/request';
import { useQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import Form from '../../components/json-forms/Form';
// import { pdfjs } from "react-pdf";
// pdfjs.GlobalWorkerOptions.workerSrc =
//   "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
// import "react-pdf/dist/Page/TextLayer.css";
// import "react-pdf/dist/Page/AnnotationLayer.css";


export default function RecruitmentFormsListPage() {
  const { loading, error, payload } = useQuery(getJsonFormsAction());
  const [selectedForm, setSelectedForm] = React.useState(null);
  const [identifier, setIdentifier] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [version, setVersion] = React.useState(null);


  React.useEffect(() => {
    if (!loading && !error) {
      setRows(payload.results);
    }
  }, [loading]);

  const handleChange = e => {
    setSelectedForm(e.target.value);
    const found = rows.find(element => element.id === e.target.value);
    if (!_.isNil(found)) {
      setIdentifier(found.identifier);
      setVersion(found.version);
    }
  };

  const handleReset = () => {
    setSelectedForm(null);
    setIdentifier(null);
    setVersion(null);
  };

  return (
    <Page title="Rekrutacja">
      <Button onClick={handleReset} sx={{ mb: 2 }}>Resetuj</Button>
      <FormControl fullWidth sx={{ mb: 4 }}>
        <InputLabel>Formularze</InputLabel>
        <Select
          fullWidth
          value={selectedForm}
          onChange={handleChange}
          input={<OutlinedInput label="Formularze" />}
          MenuProps={{ PaperProps: { sx: { maxHeight: '55vh' } } }}
        >
          {rows.map(row => (
            <MenuItem key={row.id} value={row.id}>
              <ListItemText primary={`${row.identifier}`} secondary={`wersja: ${row.version}`} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {identifier != null ? <Form identifier={identifier} admin={true} version={version}/> : null}
    </Page>
  );
};
